import { I18n } from 'react-redux-i18n';
import { navigate } from '@reach/router';
import StorageService from './storage';

function isAuthenticated() {
  const auth = StorageService.get('auth');
  return (auth && auth.token);
}

function get() {
  if (isAuthenticated()) {
    return StorageService.get('auth');
  }
}

function create(data) {
  StorageService.set('auth', data);
}

function reset() {
  StorageService.reset('auth');
}

function redirectToLogin() {
  return navigate(I18n.t('routes.login.url'));
}

export default {
  get,
  isAuthenticated,
  create,
  reset,
  redirectToLogin,
};
